function FeaturePageNL() {
  return (
    <div className="manual">
      <article className="manual__toc">
        <div className="manual__toc__container">
          <ol>
            <li>
              <a href="#login">Inloggen</a>
            </li>
            <li>
              <a href="#dashboard">Dashboardnavigatie</a>
            </li>
            <li>
              <a href="#account">Accountnavigatie</a>{" "}
            </li>
            <li>
              <a href="#profile">Profielgebied</a>
            </li>
            <li>
              <a href="#home">Startscherm</a>
            </li>
            <li>
              <a href="#projects">Projecten</a>
            </li>
            <li>
              <a href="#reorder">Herordening items</a>
            </li>
            <li>
              <a href="#cart">Winkelwagen</a>
            </li>
            <li>
              <a href="#checkout">Afrekenen</a>
            </li>
            <li>
              <a href="#orders">Bestellingen</a>
            </li>
            <li>
              <a href="#pending">In behandeling</a>
            </li>
            <li>
              <a href="#shipped">Verzonden bestellingen</a>
            </li>
            <li>
              <a href="#statuses">Bestelstatussen</a>
            </li>
            <li>
              <a href="#types">Besteltypen</a>
            </li>
            <li>
              <a href="#instore-order">Instore Week-bestelling plaatsen</a>
            </li>
            <li>
              <a href="#instore-view">Instore-bestellingen bekijken</a>
            </li>
            <li>
              <a href="#instore-approve">Instore-bestellingen goedkeuren</a>
            </li>
          </ol>
        </div>
      </article>

      <main className="manual__text">
        <h2 id="login">1. Inloggen</h2>
        <ul>
          <li>
            Het portaal is toegankelijk via het bekende Sharepoint-platform.
          </li>
          <li>
            Een winkel e-mailadres en wachtwoord worden gebruikt om in te
            loggen.
          </li>
          <li>
            De gebruiker wordt ingelogd via Single Sign On, wat betekent dat de
            gebruiker geen extra gebruikersnaam en inloggegevens heeft voor deze
            applicatie.
          </li>
          <li>
            Deze informatie wordt verstrekt door de IT-afdeling van Rituals.
          </li>
        </ul>

        <div className="manual__text__warning">
          <div className="manual__text__warning__eyecather">BELANGRIJK!</div>
          <p>
            Alle verdere functies zijn alleen toegankelijk na succesvol
            inloggen.
          </p>
        </div>

        <h2 id="dashboard">2. Dashboardnavigatie</h2>
        <p>
          De gebruiker heeft toegang tot een navigatiegebied in dashboardstijl.
          Dit bevindt zich aan de linkerkant van de applicatie.
        </p>
        <p>
          Het gebied is altijd zichtbaar met standaard tekst. Dit kan worden
          ingeklapt voor een beter gebruik van het scherm met de "X"-knop
          linksboven. Het gebied kan weer worden uitgevouwen door op de "="-knop
          te klikken die de "X"-knop vervangt.
        </p>

        <p>
          Welke knoppen je ziet, hangt af van je rol. Een winkel ziet de
          onderstaande basisknoppen; het hoofdkantoor ziet daarnaast nog extra
          knoppen (zoals "stores").
        </p>
        <ul>
          <li>
            <span>"home": </span>leidt naar de startpagina. Pictogram: Oog.
          </li>
          <li>
            <span>"projecten": </span>leidt naar de lijst met alle huidige
            beschikbare projecten. Pictogram: Promotiebord.
          </li>
          <li>
            <span>"stores" (alleen hoofdkantoor): </span>leidt naar het
            winkeloverzicht. Pictogram: Winkel.
          </li>
          <li>
            <span>"orders": </span>leidt naar de bestelgeschiedenis van de aan
            de gebruiker gekoppelde winkel. Pictogram: Klok. Op deze knop kan
            een rood cirkeltje met een getal verschijnen: het aantal
            bestellingen dat nog op een actie van jou wacht (bv. goed te
            keuren).
          </li>
          <li>
            <span>"how-to": </span>leidt naar deze handleiding. Pictogram:
            Vraagteken.
          </li>
        </ul>

        <h2 id="account">3. Accountnavigatie</h2>
        <p>
          Het <strong>"Accountnavigatie"</strong>-gebied bevindt zich
          rechtsboven in het dashboard van de applicatie.
        </p>
        <p>De gebruiker heeft toegang tot:</p>
        <ul>
          <li>
            Een <strong>"Winkelwagen"</strong> pictogram, leeg of met een
            gekleurd cirkeltje met een getal dat het aantal verschillende items
            in de winkelwagen weergeeft. Het icoon verwijst naar het mandje dat
            op dat moment actief is; de kleur geeft het type aan:{" "}
            <strong>rood</strong> voor een project-/promobestelling en{" "}
            <strong>paars</strong> voor een instore-bestelling (Week).
          </li>
          <li>
            Een <strong>"Gebruikersnaam"</strong>.
          </li>
          <li>
            Een <strong>"Avatar"</strong> pictogram. Dit pictogram is een
            weergegeven pixelachtige afbeelding, geïnterpoleerd uit de
            gebruikersnaam en is niet aanpasbaar. Als je op de avatar tikt,
            wordt het <strong>"Profielgebied"</strong> geactiveerd aan de
            rechterkant van het scherm. Voor meer informatie over het{" "}
            <strong>"Profielgebied"</strong>, zie{" "}
            <strong>"Profielgebied"</strong>.
          </li>
        </ul>

        <div className="manual__text__warning">
          <div className="manual__text__warning__eyecather">BELANGRIJK!</div>
          <p>
            Je kunt niet tegelijk een project-winkelwagen én een
            instore-winkelwagen open hebben; daarom toont het icoon er altijd
            maar één. Rond de lopende bestelling eerst af (of leeg de
            winkelwagen) voordat je met het andere type begint.
          </p>
        </div>

        <h2 id="profile">4. Profielgebied</h2>
        <p>
          Het <strong>"Profielgebied"</strong> is een heel eenvoudige maar
          effectieve plek om de <strong>"Gebruikersinformatie"</strong> en de{" "}
          <strong>"Winkel informatie"</strong> te bekijken. De knop "Uitloggen"
          logt de gebruiker uit van de applicatie en keert terug naar de
          inlogpagina.
        </p>
        <p>
          Zie <strong>"Inloggen"</strong>. De <strong>"Winkelwagen"</strong> van
          de gebruiker wordt niet geleegd bij het uitloggen en wordt bewaard
          voor latere bestellingen!
        </p>
        <p>
          In het geval dat de gebruiker niet wil uitloggen en alleen gebruikers-
          of winkelgegevens wil bekijken, kan het gebied worden ingeklapt door
          te klikken op de nu groter weergegeven Avatar bovenaan of door links
          op de witte ruimte te tikken.
        </p>
        <h2 id="home">5. Home</h2>
        <p>
          Een overzichtelijke en georganiseerde weergave, met toegangslinks tot
          verschillende functies:
        </p>
        <ol>
          <li>
            <span>"Mijn geschiedenis": </span>Deze knop leidt de gebruiker
            direct naar de "geschiedenis" van de winkel.
          </li>
          <li>
            <span>"DYNAMISCHE QUICKLINK": </span>Ongeacht of de{" "}
            <strong>"Winkelwagen"</strong> van de gebruiker leeg is of niet, zal
            deze link van doel veranderen:
            <ul>
              <li>
                <span>"Opnieuw bestellen vanuit dit project": </span>Wanneer de{" "}
                <strong>"Winkelwagen"</strong> van de gebruiker leeg is, wordt
                de gebruiker direct naar de lijst met opnieuw te bestellen items
                van dit specifieke project geleid. Dit heeft alleen betrekking
                op het laatste project.
              </li>
              <li>
                <span>"Project in winkelwagen": </span>Wanneer de{" "}
                <strong>"Winkelwagen"</strong> van de gebruiker 1 of meer items
                bevat, wordt de gebruiker naar de lijst met opnieuw te bestellen
                items van het project met items in de winkelwagen geleid.
              </li>
            </ul>
          </li>
          <div className="manual__text__warning">
            <div className="manual__text__warning__eyecather">BELANGRIJK!</div>
            <p>
              Het is niet mogelijk om te bestellen uit verschillende projecten
              in deze versie van de applicatie.
            </p>
          </div>
          <li>
            <span>"Beschikbare projecten": </span>Deze knop leidt de gebruiker
            naar alle huidige beschikbare projecten.
          </li>
          <li>
            <span>"Doorgaan met winkelwagen": </span>Deze knop leidt de
            gebruiker naar de <strong>"Winkelwagen"</strong>. Deze knop is
            alleen zichtbaar wanneer de <strong>"Winkelwagen"</strong> van de
            gebruiker niet leeg is.
          </li>
        </ol>

        <h2 id="projects">6. Projecten</h2>
        <p>
          Op deze pagina wordt een overzicht weergegeven van recente beschikbare
          promotionele projecten van Rituals. De gebruiker kan vanaf deze pagina
          doorverwezen worden naar de pagina met opnieuw te bestellen items van
          dit specifieke project. Als de <strong>"Winkelwagen"</strong> van de
          gebruiker niet leeg is, is alleen het project met items in de
          winkelwagen toegankelijk. Om items uit een ander project te bestellen,
          moet het huidige winkelmandje worden voltooid of volledig worden
          leeggemaakt. Zie <strong>"Winkelwagen"</strong>. De momenteel
          geselecteerde projectcode is ook zichtbaar onder aan de lijst, ter
          referentie.
        </p>
        <p>
          Bovenaan deze lijst kan daarnaast een actief{" "}
          <strong>"Week orders"</strong>-item verschijnen: een open
          instore-project voor de wekelijkse bestellingen. Dit item is alleen
          zichtbaar zolang er voor jouw winkel een Week-sjabloon beschikbaar is
          (binnen de geldige periode, met een datumvermelding "beschikbaar van …
          tot …"). Via de <strong>"BESTELLEN"</strong>-knop start je een
          Week-bestelling — zie{" "}
          <strong>"Instore Week-bestelling plaatsen"</strong>. Deze knop is
          uitgeschakeld zolang je een project-winkelwagen open hebt staan.
        </p>

        <h2 id="reorder">
          7. Beschikbare opnieuw te bestellen items van recent project
        </h2>
        <p>
          Wanneer een project is geselecteerd, wordt de gebruiker doorverwezen
          naar de bestelbare items van dit project. Dit is de kernpagina van de
          applicatie. Het is een standaard webshopstijl-overzicht met alle
          beschikbare bestelbare items van een specifiek project.
        </p>
        <ul>
          <li>
            Aan de rechterkant, net onder het <strong>"Accountgebied"</strong>,
            wordt de "Originele Bestelling" (zie Bestellingstypen) geplaatst,
            ter referentie van de gebruiker.
          </li>
          <li>
            Afhankelijk van de grootte van het project zijn er veel bestelbare
            items georganiseerd in een raster. Elk bestelbaar item heeft zijn
            eigen "Kaart".
          </li>
        </ul>

        <h4 id="reorder-card">7a. Herbestelbare kaart</h4>
        <ul>
          <li>Afbeelding van het product</li>
          <li>Productnaam</li>
          <li>
            Hoeveelheid ontvangen bij de start van het oorspronkelijke project.{" "}
          </li>
          <div className="manual__text__warning">
            <div className="manual__text__warning__eyecather">BELANGRIJK!</div>
            <p>
              De maximale "herbestelbare" hoeveelheid is gelijk aan de ontvangen
              hoeveelheid in het oorspronkelijke project.
            </p>
          </div>
          <li>
            <span>"TOEVOEGEN"-knop: </span>Voeg dit product toe aan de
            winkelwagen met de in de eigenschap "hoeveelheid" gespecificeerde
            hoeveelheid ernaast.
          </li>
          <li>
            <span>"Hoeveelheid": </span>verhoog, verlaag of typ de gewenste
            hoeveelheid in.
          </li>
        </ul>

        <p>
          Wanneer de gebruiker voor de eerste keer op de "TOEVOEGEN"-knop van
          een item klikt, wordt de gebruiker gevraagd om de "Reden" op te geven
          waarom de gebruiker dit specifieke item opnieuw wil bestellen. Zie
          "7b. Lijst met redenen".
        </p>

        <h4>7b. Lijst met redenen</h4>
        <ul>
          <li>
            Dit is een lijst van veelvoorkomende redenen waarom een item opnieuw
            moet worden besteld en zal in de loop van de tijd
            veranderen/groeien.
          </li>
        </ul>

        <h2 id="cart">8. Winkelwagen</h2>
        <p>
          Dit vertegenwoordigt de lijst met toegevoegde items in de{" "}
          <strong>"Winkelwagen"</strong> van de gebruiker.
        </p>
        <h3>Een rij van een item bevat:</h3>
        <ul>
          <li>Een miniatuurafbeelding;</li>
          <li>De productnaam;</li>
          <li>De reden voor het opnieuw bestellen van het item;</li>
          <li>Knoppen om de hoeveelheid te verhogen of te verlagen;</li>
          <li>
            Een knop om het item uit de <strong>"Winkelwagen"</strong> van de
            gebruiker te verwijderen. Pictogram: Prullenbak
          </li>
        </ul>
        <h3>Er zijn 3 oproep tot actieknoppen onder de lijst:</h3>
        <ul>
          <li>
            <span>"MEER TOEVOEGEN"-knop: </span>leidt de gebruiker terug naar de
            pagina met opnieuw te bestellen items.
          </li>
          <li>
            <span>"WINKELWAGEN VERWIJDEREN"-knop: </span>LET OP! deze actie
            verwijdert elk item uit de winkelwagen samen met de winkelwagen
            zelf, zodat er een ander project kan worden gekozen om te bestellen.
          </li>
          <li>
            <span>"VOLGENDE STAP"-knop: </span>leidt de gebruiker naar de pagina
            voor het afrekenen om de bestelling af te ronden.
          </li>
        </ul>

        <h2 id="checkout">9. Afrekenen</h2>
        <ul>
          <li>
            Een snel overzicht van alle opnieuw te bestellen items, klaar om te
            bestellen;
          </li>
          <li>
            Een kort overzicht van de <b>"Winkelgegevens"</b>;
          </li>
          <li>
            Een kort overzicht van het <b>"Verzendadres"</b>;
          </li>
          <li>
            Een tekstveld om eventuele opmerkingen in te voeren, indien nodig;
          </li>
          <li>
            Een <b>"BESTELLING BEVESTIGEN"</b>-knop.
          </li>
        </ul>
        <br />
        <p>
          Wanneer de gebruiker een bestelling bevestigt, wordt de bestelling
          naar het hoofdkantoor van Rituals gestuurd ter goedkeuring.
        </p>
        <p>
          Er verschijnt een pop-up met de bevestiging dat de bestelling naar het
          hoofdkantoor van Rituals wordt verzonden.
        </p>

        <h2 id="orders">10. Bestellingen</h2>
        <p>
          Op de pagina "bestellingen" staat een overzicht van alle bestellingen
          die de winkel in de loop van de tijd heeft geplaatst. Deze lijst kan
          oplopend of aflopend gesorteerd worden door te klikken op de knop met
          pijlen in de koptekst van de kolom.
        </p>
        <p>
          De bestellingen zijn opgesplitst in twee tabbladen:{" "}
          <strong>"Promo"</strong> (de projectbestellingen die hierboven zijn
          beschreven) en <strong>"Instore"</strong>. Zie{" "}
          <strong>"Instore-bestellingen bekijken"</strong> voor meer over het
          instore-tabblad.
        </p>
        <p>
          Aan de linkerkant is er een filterknop om het filtermenu te openen.
        </p>
        <p>De bestelgeschiedenis kan worden gefilterd op:</p>
        <ul>
          <li>Promocode</li>
          <li>Bestelstatus</li>
          <li>Besteltype</li>
        </ul>
        <p>Het is ook mogelijk om te gaan zoeken op bestel code</p>
        <br />
        <p>
          Wanneer een winkel meer dan 20 bestellingen heeft geplaatst, wordt de
          geschiedenispagina in de loop van de tijd gepagineerd. Onder aan de
          tabel verschijnt een balk met paginagegevens. Klik op de pijl of het
          paginanummer om door alle bestellingen te navigeren.
        </p>

        <h2 id="pending">11. In behandeling</h2>
        <p>
          De pagina met "in behandeling zijnde" bestellingen is een vooraf
          gedefinieerde filter op de geschiedenispagina. Deze pagina is gemaakt
          voor het gemak van de gebruiker.
        </p>
        <p>
          De pagina toont een bestelgeschiedenis, maar gefilterd op de
          bestelstatus "In behandeling" en het besteltype "Nalevering", dus met
          uitzondering van alle "Originele" bestellingen.
        </p>

        <h2 id="shipped">12. Verzonden</h2>
        <p>
          De pagina met "verzonden" bestellingen is ook een vooraf gedefinieerde
          filter op de geschiedenispagina. Deze pagina is gemaakt voor het gemak
          van de gebruiker. Het toont een bestelgeschiedenis, maar gefilterd op
          de bestelstatus "Verzonden" en het besteltype "Nalevering", dus met
          uitzondering van alle "Originele" bestellingen.
        </p>
        <p>
          Verzonden bestellingen kunnen een <strong>"track &amp; trace"</strong>{" "}
          krijgen. Wanneer dit beschikbaar is, verschijnt er een groene{" "}
          <strong>"TRACK &amp; TRACE"</strong>-knop waarmee je het pakket kunt
          volgen. Bestaat een bestelling uit meerdere pakketten, dan opent de
          knop een lijstje ("Pakket 1", "Pakket 2", …) met een link per pakket.
        </p>

        <h2 id="statuses">13. Bestelstatussen</h2>
        <p>
          Ter referentie: een bestelling doorloopt deze statussen. Promo- en
          instore-bestellingen delen dezelfde statussen:
        </p>
        <ol>
          <li>
            <span>"In behandeling" (Pending): </span>de bestelling is ter
            goedkeuring naar het hoofdkantoor van Rituals gestuurd;
          </li>
          <li>
            <span>"Besteld" (Ordered): </span>de bestelling is goedgekeurd door
            het hoofdkantoor en in productie/voorbereiding genomen;
          </li>
          <li>
            <span>"In productie" (In progress): </span>de bestelling wordt
            klaargemaakt voor verzending;
          </li>
          <li>
            <span>"Verzonden" (Shipped): </span>de bestelling is verzonden;
          </li>
          <li>
            <span>"Geleverd" (Delivered): </span>de bestelling is afgeleverd bij
            de winkel;
          </li>
          <li>
            <span>"Gearchiveerd" (Archived): </span>de afgehandelde bestelling
            is naar het archief verplaatst;
          </li>
          <li>
            <span>"Geannuleerd" (Cancelled): </span>de bestelling is geannuleerd
            door het hoofdkantoor van Rituals.
          </li>
        </ol>
        <div className="manual__text__warning">
          <div className="manual__text__warning__eyecather">BELANGRIJK!</div>
          <p>
            Voor een winkel worden gearchiveerde bestellingen weergegeven als{" "}
            <strong>"Geleverd"</strong>.
          </p>
        </div>

        <p>Ter referentie kan een bestelling ook deze status hebben:</p>
        <ul>
          <li>"Aangemaakt" (Created).</li>
        </ul>

        <h2 id="types">14. Besteltypes</h2>
        <p>
          Ter referentie: een bestelling kan een van deze besteltypelabels
          hebben.
        </p>
        <h3>Promo-bestellingen:</h3>
        <ol>
          <li>
            <span>"Origineel": </span>de oorspronkelijke bestelling voor uw
            winkel, gemaakt door het hoofdkantoor van Rituals in de
            projectcontext;
          </li>
          <li>
            <span>"Nalevering": </span>de bestelling die een winkel heeft
            geplaatst in de naleveringsweek na het project;
          </li>
        </ol>
        <h3>Instore-bestellingen:</h3>
        <ol>
          <li>
            <span>"Week": </span>de wekelijkse instore-bestelling op basis van
            een actief sjabloon;
          </li>
          <li>
            <span>"Opening": </span>een bestelling rond de opening van een
            winkel;
          </li>
          <li>
            <span>"Relocation": </span>een bestelling rond een verhuizing of
            heropening van een winkel.
          </li>
        </ol>

        <h2 id="instore-order">15. Instore Week-bestelling plaatsen</h2>
        <p>
          Een winkel kan zelf <strong>Week</strong>-instorebestellingen
          plaatsen. Dit gaat via <strong>"Projecten"</strong>: zodra er voor jouw
          winkel een actief Week-sjabloon beschikbaar is, verschijnt bovenaan de
          lijst een item <strong>"Week orders"</strong> met een{" "}
          <strong>"BESTELLEN"</strong>-knop.
        </p>
        <p>
          De flow lijkt sterk op het opnieuw bestellen van projectitems (zie{" "}
          <strong>"Winkelwagen"</strong> en <strong>"Afrekenen"</strong>):
        </p>
        <ol>
          <li>
            Kies op de Week-pagina de gewenste artikelen en stel per artikel de{" "}
            <strong>hoeveelheid</strong> in. Sommige artikelen vragen om extra
            personalisatie-gegevens ("perso").
          </li>
          <li>
            De gekozen artikelen komen in je{" "}
            <strong>instore-winkelwagen</strong> ("My instore basket"), met
            knoppen "Meer toevoegen", "Winkelwagen verwijderen" en "Volgende
            stap".
          </li>
          <li>
            Op de <strong>afrekenpagina</strong> zie je de winkelgegevens, het
            bezorgadres en het aantal artikelen. Heeft je winkel nog geen taal
            ingesteld, dan kies je hier eerst een taal. Klik daarna op{" "}
            <strong>"Bestelling bevestigen"</strong>.
          </li>
        </ol>
        <div className="manual__text__warning">
          <div className="manual__text__warning__eyecather">BELANGRIJK!</div>
          <p>
            Een winkel kan niet tegelijk een project-winkelwagen én een
            instore-winkelwagen open hebben. Rond de lopende bestelling eerst af
            (of leeg de winkelwagen) voor je een andere start.
          </p>
        </div>
        <p>
          Na het bevestigen wordt de bestelling geplaatst en keer je terug naar
          het startscherm. Of de bestelling eerst nog goedgekeurd moet worden,
          hangt af van de omvang:
        </p>
        <ul>
          <li>
            <strong>20 orderregels of minder</strong> (verschillende artikelen):
            de bestelling wordt meteen op <strong>"Besteld"</strong> gezet — geen
            goedkeuring nodig.
          </li>
          <li>
            <strong>Meer dan 20 orderregels</strong>: de bestelling gaat eerst
            ter goedkeuring naar het hoofdkantoor (status{" "}
            <strong>"In behandeling"</strong>).
          </li>
        </ul>
        <div className="manual__text__warning">
          <div className="manual__text__warning__eyecather">BELANGRIJK!</div>
          <p>
            Een winkel plaatst alleen <strong>Week</strong>-bestellingen.
            Opening- en Relocation-bestellingen worden door het hoofdkantoor
            aangemaakt.
          </p>
        </div>

        <h2 id="instore-view">16. Instore-bestellingen bekijken</h2>
        <p>
          Je geplaatste instore-bestellingen vind je terug via{" "}
          <strong>"Bestellingen"</strong> in het dashboard, op het tabblad{" "}
          <strong>"Instore"</strong>.
        </p>
        <p>De lijst toont per bestelling onder andere:</p>
        <ul>
          <li>de besteldatum en bestelcode;</li>
          <li>het besteltype en de bestelstatus;</li>
          <li>de taal van de winkel;</li>
          <li>het aantal artikelen;</li>
          <li>een eventuele opmerking;</li>
          <li>de track &amp; trace.</li>
        </ul>
        <p>
          Klik op het <strong>oog-pictogram</strong> om de details van een
          bestelling te openen: de winkelgegevens, het bezorgadres, de bestelde
          artikelen en de tracking-links.
        </p>
        <div className="manual__text__warning">
          <div className="manual__text__warning__eyecather">BELANGRIJK!</div>
          <p>
            Dit tabblad is <strong>alleen-lezen</strong>: je bekijkt en volgt
            hier bestaande bestellingen. Een nieuwe Week-bestelling plaats je via{" "}
            <strong>"Projecten"</strong> — zie{" "}
            <strong>"Instore Week-bestelling plaatsen"</strong>.
          </p>
        </div>

        <h2 id="instore-approve">17. Instore-bestellingen goedkeuren</h2>
        <p>
          Deze sectie is bedoeld voor gebruikers van het hoofdkantoor (HQ).
        </p>
        <p>
          Als HQ-gebruiker keur je instore-bestellingen goed. Open{" "}
          <strong>"Bestellingen"</strong> en kies het tabblad{" "}
          <strong>"Instore"</strong>. Staan er bestellingen klaar ter
          goedkeuring, dan kom je automatisch op de{" "}
          <strong>"Approve"</strong>-weergave terecht.
        </p>
        <ul>
          <li>
            Je kunt een bestelling per rij goedkeuren, of meerdere bestellingen
            selecteren en in bulk goedkeuren.
          </li>
          <li>
            Een bestelling die niet door mag, kun je{" "}
            <strong>annuleren</strong>.
          </li>
        </ul>
        <p>
          Na goedkeuring krijgt de bestelling de status{" "}
          <strong>"Besteld" (Ordered)</strong> en neemt het verdere logistieke
          traject het over.
        </p>
      </main>
    </div>
  );
}

export default FeaturePageNL;
